<template>
  <div class="organization">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <!-- 标题 -->
        <span class="font-sz24">{{ $t('工程动态标签.工程动态标签') }}</span>
        <div class="head-text">
          <el-button type="primary" @click="
            weiboName = '';
          addDialogFormVisible = true;
          ">{{ $t('common.添加') }}</el-button>
        </div>
      </div>
      <div class="rygl-table">
        <el-table :data="inform" height="72vh" v-loading="loading">
          <el-table-column align="center" type="selection" width="55"></el-table-column>
          <el-table-column align="center" type="index" :label="$t('工程动态标签.序号')"></el-table-column>
          <el-table-column align="center" prop="pwst03" :label="$t('工程动态标签.名称')"></el-table-column>
          <el-table-column align="center" prop="pwst04N" :label="$t('工程动态标签.更新时间')"></el-table-column>
          <el-table-column align="center" :label="$t('工程动态标签.操作')" width="400">
            <template slot-scope="scope">
              <el-button size="small" type="primary" plain @click="UpdateName(scope.row)">{{ $t('工程动态标签.重命名')
              }}</el-button>
              <el-button size="small" type="danger" plain @click="deleteinfo(scope.row)">{{ $t('common.删除')
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 新增 -->
      <el-dialog :close-on-click-modal="false" :title="$t('common.添加')" width="30%"
        :visible.sync="addDialogFormVisible">
        <el-row>
          <el-col :span="18">
            <el-input type="text" show-word-limit :placeholder="$t('工程动态标签.名称')" v-model="weiboName"></el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" class="mar-bot20" @click="AddOrUpdatePweiboSet()">{{ $t('common.确定')
            }}</el-button>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 重命名 -->
      <el-dialog :close-on-click-modal="false" :title="$t('工程动态标签.重命名')" width="30%"
        :visible.sync="addDialogFormVisibleName">
        <el-row>
          <el-col :span="18">
            <el-input type="text" maxlength="5" show-word-limit v-model="weiboName"
              :placeholder="$t('工程动态标签.名称')"></el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="AddOrUpdatePweiboSet()">{{ $t('common.确定') }}</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  GetPweiboSetList,
  AddOrUpdatePweiboSet,
  DelPweiboSet,
} from "@/setAxios.js";
export default {
  name: "ProjectInformation",
  data() {
    return {
      loading: false,
      inform: [],
      addDialogFormVisible: false,
      addDialogFormVisibleName: false,
      weiboName: "",
      id: 0,
    };
  },
  methods: {
    async AddOrUpdatePweiboSet() {
      let params = {
        pwst01: this.id,
        pwst02: localStorage.xid,
        pwst03: this.weiboName,
        pwst04: new Date(),
      };
      let res = await AddOrUpdatePweiboSet(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: this.$t('common.处理成功')
        });
        this.addDialogFormVisible = false;
        this.addDialogFormVisibleName = false;
        this.getData();
      } else {
        this.$message.error(res.Message);
      }
    },
    //   重命名
    UpdateName(row) {
      this.addDialogFormVisibleName = true;
      this.weiboName = row.pwst03;
      this.id = row.pwst01;
    },
    //   删除
    deleteinfo(row) {
      this.$confirm(this.$t('common.删除询问'), this.$t('common.提示'), {
        confirmButtonText: this.$t('common.确定'),
        cancelButtonText: this.$t('common.取消'),
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row.pwst01,
          };
          DelPweiboSet(params).then((res) => {
            this.$message({
              type: "success",
              message: this.$t('common.处理成功')
            });
            this.getData();
          });
          this.getData();
        })
    },
    // 获取所有数据
    getData() {
      this.loading = true;
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetPweiboSetList(params).then((res) => {
        this.inform = res.Data;
        this.loading = false;
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style scoped>
/* 新增 */
.font-sz24 {
  font-size: 24px;
}

.mar-bot20 {
  margin-bottom: 20;
}

.head-text {
  float: right;
  margin-top: -4px;
}
</style>
